import { PropsWithChildren, useMemo } from "react";
import { ApolloProvider } from "@apollo/client";
import { ApolloProvider as ApolloHooksProvider } from "@apollo/client";
import { History } from "history";
import { Router } from "react-router";
import getApolloClient from "../apollo";
import { SupportedLanguages } from "../generated/graphql";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { SELECTED_LANGUAGE_KEY } from "../utils/i18n/utils";
import { Toaster } from "./Common/Toaster";
import CompatibilityCheck from "./CompatibilityCheck";
import ErrorBoundary from "./ErrorBoundary";

export type AppType = "guest" | "client";

type AppScaffoldProps = { history: History; app?: AppType };

export const AppScaffold = ({
  history,
  app = "client",
  children,
}: PropsWithChildren<AppScaffoldProps>) => {
  const { getValue } = useLocalStorage<SupportedLanguages>({
    key: SELECTED_LANGUAGE_KEY,
  });

  const language = getValue();

  const ApolloClient = useMemo(
    () => getApolloClient(app, language),
    [app, language],
  );

  return (
    <>
      <ApolloProvider client={ApolloClient}>
        <ApolloHooksProvider client={ApolloClient}>
          <CompatibilityCheck app={app}>
            <Router history={history}>
              <ErrorBoundary>{children}</ErrorBoundary>
            </Router>
          </CompatibilityCheck>
        </ApolloHooksProvider>
      </ApolloProvider>
      <Toaster />
    </>
  );
};
